import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InviteTile from './InviteTile';
import '../../../../styles/EventInvitedList.scss';


const InvitedList = props => {
  const { t } = useTranslation()
  const {scheduleInvited, scheduleNotInvited} = props;

  return (
    
    <div className='event-invited-list-container'>
      {scheduleInvited.length ? (
        <>
          <p className='paragraph--darkGray paragraph--small'>{t('schedulerSuccessLabel')}</p>
          <div className='event-invited-list'>
            {scheduleInvited.map (schl => (
              <InviteTile errors={schl.errors} data={schl}  key={schl.newId}/>
          ))}
          </div>
        </>
      ) : (
        <p className='paragraph--default paragraph--charcoal paragraph--bold'>{t('schedulerFailedLabel')}</p>
      )}
      {scheduleNotInvited.length ? (
        <div className='m-t-36'>
          <p className='paragraph--darkGray paragraph--small'>{t('schedulerNotSuccessLabel')}</p>
          <div className='event-invited-list'>
            {scheduleNotInvited.map (schl => (
               <InviteTile errors={schl.errors} data={schl}  key={schl.newId}/>
              
                ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

InvitedList.propTypes = {
  scheduleInvited: PropTypes.array,
  scheduleNotInvited: PropTypes.array
};

InvitedList.defaultProps = {
  scheduleInvited: [],
  scheduleNotInvited: []
}

export default InvitedList;